import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface InnerPageHeroProps {
  bgImage: string;
  bgAlt: string;
  bgTitle?: string;
  breadcrumbLabel: string;
  children: ReactNode;
}

export default function InnerPageHero({ bgImage, bgAlt, bgTitle, breadcrumbLabel, children }: InnerPageHeroProps) {
  return (
    <section className="relative pt-28 pb-12 md:pt-36 md:pb-16 px-4 md:px-6 lg:px-10 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={bgImage}
          alt={bgAlt}
          title={bgTitle || bgAlt}
          className="w-full h-full object-cover object-top"
        />
        {/* Dark overlay with subtle green tint for brand cohesion */}
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/65 to-foreground-950/55"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-sm text-background-300/70 mb-6">
          <Link to="/" className="hover:text-background-50 transition-colors duration-200">
            Home
          </Link>
          <i className="ri-arrow-right-s-line text-[10px]"></i>
          <span className="text-background-50/80 font-medium">{breadcrumbLabel}</span>
        </div>

        {/* Page Content */}
        {children}
      </div>
    </section>
  );
}